import { Copy } from "lucide-react";
import { DAY_LABELS } from "@/lib/constants";
import { hoursFor } from "@/lib/time";
import { Input } from "@/components/ui/input";

const t = "rounded-lg bg-white border-[#103080]/20 h-9 text-sm px-2";
const FIELDS = [["start", "Start"], ["end", "Finish"], ["lunch_start", "Lunch from"], ["lunch_end", "Lunch to"]];

export default function WeekHoursEditor({ value, onChange, testPrefix }) {
  const days = value.days || {};
  const setDay = (i, k, v) => onChange({ ...value, days: { ...days, [String(i)]: { ...hoursFor(value, i), [k]: v } } });
  const toggle = (i) => {
    const on = value.work_days.includes(i);
    onChange({ ...value, work_days: on ? value.work_days.filter((d) => d !== i) : [...value.work_days, i].sort(), days: on ? days : { ...days, [String(i)]: hoursFor(value, i) } });
  };
  const copyFirst = () => {
    const first = value.work_days[0];
    if (first === undefined) return;
    const h = hoursFor(value, first);
    onChange({ ...value, days: Object.fromEntries(value.work_days.map((d) => [String(d), { ...h }])) });
  };
  return (
    <div className="space-y-2" data-testid={`${testPrefix}-week-hours`}>
      <div className="hidden sm:grid grid-cols-[90px_repeat(4,minmax(0,1fr))] gap-2 text-[11px] font-semibold uppercase tracking-[0.12em] text-[#0F172A]/45">
        <span>Day</span>{FIELDS.map(([, l]) => <span key={l}>{l}</span>)}
      </div>
      {DAY_LABELS.map((d, i) => {
        const on = value.work_days.includes(i);
        const h = hoursFor(value, i);
        return (
          <div key={d} className="grid grid-cols-2 sm:grid-cols-[90px_repeat(4,minmax(0,1fr))] gap-2 items-center" data-testid={`${testPrefix}-day-${d.toLowerCase()}`}>
            <button type="button" onClick={() => toggle(i)} data-testid={`${testPrefix}-toggle-${d.toLowerCase()}`}
              className={`col-span-2 sm:col-span-1 rounded-full h-9 text-xs font-semibold border transition-colors duration-200 ${on ? "bg-[#103080] text-white border-[#103080]" : "border-[#103080]/20 text-[#103080]/60 hover:border-[#0090D0]"}`}>{d}{!on && " · off"}</button>
            {on ? FIELDS.map(([k, l]) => (
              <Input key={k} type="time" aria-label={`${d} ${l}`} value={h[k] || ""} onChange={(e) => setDay(i, k, e.target.value)} className={t} data-testid={`${testPrefix}-${d.toLowerCase()}-${k}`} />
            )) : <span className="col-span-2 sm:col-span-4 text-xs text-[#0F172A]/40">Not working</span>}
          </div>
        );
      })}
      <button type="button" onClick={copyFirst} data-testid={`${testPrefix}-copy-first`}
        className="inline-flex items-center gap-1.5 text-xs font-semibold text-[#0090D0] hover:text-[#103080] transition-colors duration-200"><Copy size={12} /> Copy first working day to all working days</button>
    </div>
  );
}
